import { delay, put, select } from 'typed-redux-saga';
import logger from '../../../logger';
import selectSessionContent from '../../session/selectors/selectSessionContent';
import { setTokens } from '../../session/sessionSlice';

const millisecondsInSecond = 1000;
const expireBeforeSeconds = 30;

function* cleanCsrSessionTokensSaga(): Generator {
  const { tokens } = yield* select(selectSessionContent);
  if (tokens !== null) {
    const expiresInSeconds = Math.max(0, tokens.expiresInSeconds - expireBeforeSeconds);
    yield* delay(expiresInSeconds * millisecondsInSecond);
    logger.info('Anonymous session expired. Cleaning tokens');
    yield* put(
      setTokens({
        localChange: true,
        tokens: null
      })
    );
  }
}

export default cleanCsrSessionTokensSaga;
